import Container from "../components/Container";
import {GiGears} from "react-icons/gi";
import { IoHelpBuoy } from "react-icons/io5";
import {IoMdArrowForward} from "react-icons/io";
import {FaFacebookF, FaInstagram, FaLinkedin} from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6";
import {MdEmail} from "react-icons/md";
import Hero from "../widgets/Homepage/Hero";
import Benefits from "../widgets/Homepage/Benefits";
import Difference from "../widgets/Homepage/Difference";
import { FaUsers } from "react-icons/fa";
import {Link} from "react-router";

export default function Home(props) {
    return <>
        <Hero />

        {/*SERVICES*/}
        <Container transparent shadow={false} padding={""}>
            <div className={"flex flex-col gap-8 md:gap-0 p-2 md:p-0 md:flex-row"}>
                <div
                    className={"flex-1 rounded-l-3xl rounded-r-3xl md:rounded-r-none px-4 py-8 text-gray-900 bg-blue-200 flex items-center gap-4"}>
                    <div>
                        <IoHelpBuoy className={"text-7xl text-blue-900"}/>
                    </div>
                    <div className={"space-y-2"}>
                        <div className={"text-lg font-semibold"}>Our Services</div>
                        <div>
                            Property Valuations, Scout training & mentorship, and more...
                        </div>
                        <Link to={"/services"} className={"flex items-center gap-2 cursor-pointer text-blue-600 hover:text-blue-800"}>
                            <span>Read More</span>
                            <IoMdArrowForward/>
                        </Link>
                    </div>
                </div>

                <div
                    className={"flex-1  rounded-3xl md:rounded-none  px-4 py-8 text-gray-900 bg-blue-200 flex items-center gap-4"}>
                    <div>
                        <GiGears className={"text-7xl text-blue-900"}/>
                    </div>
                    <div className={"space-y-2"}>
                        <div className={"text-lg font-semibold"}>Our Technologies</div>
                        <div>
                            Industry-level software for property listings...
                        </div>
                        <Link to={"/services"} className={"flex items-center gap-2 cursor-pointer text-blue-600 hover:text-blue-800"}>
                            <span>Read More</span>
                            <IoMdArrowForward/>
                        </Link>
                    </div>
                </div>

                <div
                    className={"flex-1 rounded-l-3xl md:rounded-l-none rounded-r-3xl px-4 py-8 text-gray-900 bg-blue-200 flex items-center gap-4"}>
                    <div>
                        <FaUsers className={"text-7xl text-blue-900"}/>
                    </div>
                    <div className={"space-y-2"}>
                        <div className={"text-lg font-semibold"}>Our Clients</div>
                        <div>
                            Property Valuers, Financial Institutions, Estate Agents...
                        </div>
                        <a href={"/#benefits"} className={"flex items-center gap-2 cursor-pointer text-blue-600 hover:text-blue-800"}>
                            <span>Read More</span>
                            <IoMdArrowForward/>
                        </a>
                    </div>
                </div>
            </div>
        </Container>
        {/*END SERVICES*/}

        <Benefits />

        <Difference />

        {/*    AD SECTIONS 2*/}
        <Container
            transparent
            padding={""}
            shadow={false}
            wrapperClassName={"hidden md:block"}
        >
            {/*For Large Screens*/}
            <div className="hidden md:grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-4">
                <div className="col-span-4 w-full py-24 px-2 md:order-last space-y-6">
                    <div className="flex gap-4 items-center">
                        <h1 className={"text-5xl font-bold"}>EMPOWERING</h1>
                        <div className={"text-sm"}>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius eveniet maxime quo! Aliquid
                            at
                            autem cum cumque dolor doloremque, doloribus eius et.
                        </div>
                    </div>

                    <h1 className={"text-5xl font-bold uppercase"}>real estate stakeholders with</h1>

                    <div className="flex gap-4 items-center">
                        <div className={"text-sm"}>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius eveniet maxime quo! Aliquid
                            at
                            autem cum cumque dolor doloremque, dolorieum excepturi.
                        </div>
                        <h1 className={"text-5xl font-bold"}>TECHNOLOGY</h1>
                    </div>
                </div>

                <div className={"col-span-2 w-full rounded-3xl md:overflow-hidden relative"}>
                    <img src="img/musa-ortac-HrrWNCpoOu8-unsplash.jpg"
                         className="w-full absolute md:left-1/2 md:top-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2"
                         alt="cover-image"
                    />
                </div>
            </div>
        </Container>
        {/*    AD SECTIONS 2*/}

        {/*    JOIN THE COMMUNITY*/}
        <div className={"bg-blue-200 w-full mt-20 py-20 text-center"}>
            <h2 className={"font-bold text-3xl"}>JOIN THE COMMUNITY</h2>

            <div className="relative inline-flex group my-8">
                <div
                    className="absolute transitiona-all duration-1000 -inset-px bg-gradient-to-r from-[#44BCFF] via-blue-200 to-[#44BCFF] rounded-xl blur-lg group-hover:opacity-50 group-hover:-inset-1 group-hover:duration-200 group-hover:scale-[1.2] animate-tilt">
                </div>
                <a href="#"
                   className="relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-blue-700 hover:bg-blue-800 font-pj rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                   role="button">
                    SIGN UP NOW
                </a>
            </div>

            <div className={"text-blue-900 font-bold border-t border-blue-100/50 my-4"}>
                OR
            </div>

            <div className={"text-blue-700 font-semibold"}>
                Subscribe to Valuations Africa to receive updates<br/>
                on Real Estate!
            </div>

            <Container
                transparent
                shadow={false}
                className={"flex gap-4 items-center"}
                outerPadding={""}
            >
                <input
                    type={"text"}
                    className={'flex-1 border-gray-300  focus:border-blue-500  focus:ring-blue-500 text-black rounded-md shadow-sm px-4 py-2'}
                    placeholder={"Email"}
                />
                <button className={"bg-blue-700 text-blue-100 px-6 py-2 rounded-lg"}>
                    Subscribe
                </button>
            </Container>

            <div className={"flex gap-4 justify-center items-center text-xl"}>
                <a href={"https://facebook.com"} className={"hover:text-white cursor-pointer p-2"}><FaFacebookF/> </a>
                <a href={"https://x.com"} className={"hover:text-white cursor-pointer p-2"}><FaXTwitter/> </a>
                <a href={"https://instagram.com"} className={"hover:text-white cursor-pointer p-2"}><FaInstagram/> </a>
                <a href={"https://linkedin.com"} className={"hover:text-white cursor-pointer p-2"}><FaLinkedin/> </a>
                <a href={"https://gmail.com"} className={"hover:text-white cursor-pointer p-2"}><MdEmail/> </a>
            </div>
        </div>
        {/*    JOIN THE COMMUNITY*/}
    </>
}